import styled from 'styled-components';
import { makeStyles, color, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const AttractLoopImage = styled.img`
  width: 100%;
  background-size: cover;
`;

export const useStyles = (props: { palette: any; fontColor: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      attractContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        background: 'transparent',
        padding: '0px 24px 0px 24px',
        minWidth: '100%'
      },
      attractInnerContainer: {
        justifyContent: 'center',
        height: 865,
        width: 1720,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '8px',
        backgroundColor: color.WHITE,
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        [theme.breakpoints.down('lg')]: {
          width: 880,
          height: 1705
        }
      },
      attractImageBlock: {
        [theme.breakpoints.down('lg')]: {
          width: '100%'
        }
      },
      slideshowTextBlock: {
        alignSelf: 'center',
        [theme.breakpoints.down('lg')]: {
          height: 735
        },
        color: props.fontColor
      },
      languageButtonsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '32px',
        paddingTop: '10px',
        width: '100%',
        '& .slick-prev:before': {
          display: 'none'
        },
        '& .slick-next:before': {
          display: 'none'
        },
        '& .slick-arrow': {
          height: '50px',
          width: '50px',
          color: 'black'
        },
        '& .slick-prev': {
          left: '-50px'
        },
        '& .slick-next': {
          right: '-50px'
        },
        '& .slick-list': {
          margin: '0 20px',
          [theme.breakpoints.down('lg')]: {
            margin: '0 10px'
          }
        }
      },
      buttonSelected: {
        alignItems: 'center',
        backgroundColor: props.palette.primary,
        border: 'none',
        display: 'flex',
        flex: '1',
        fontSize: '30px',
        justifyContent: 'center',
        margin: '5px',
        padding: 0,
        width: '220px !important',
        '& > div': {
          overflow: 'hidden',
          padding: '10px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      },
      buttonNotSelected: {
        alignItems: 'center',
        backgroundColor: color.WHITE,
        border: 'none',
        color: color.BLACK,
        display: 'flex',
        flex: '1',
        fontSize: '30px',
        justifyContent: 'center',
        margin: '5px',
        padding: 0,
        width: '220px !important',
        '& > div': {
          overflow: 'hidden',
          padding: '10px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      }
    })
  );
